<template>
    <div class="data-overview">
        <div class="overview-title">
            <span class="overview-title-text">{{ dataOverview }}</span>
            <TimePicker class="time-picker-wrapper" v-model="times" @change="dateChange" :pickerOptions="pickerOptions"/>
        </div>
        <div class="overview-panel">
            <div class="panel-item" v-for="item in overviewData" :key="item">
                <span class="item-icon">
                    <i :class="overviewItemIcon(item)"></i>
                </span>
                <div class="item-data">
                    <span v-if="overviewList[item].rate !== undefined">{{ overviewList[item].rate }}</span>
                    <span>{{ overviewList[item].num }}</span>
                    <span>{{ overviewItemLabel(item) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TimePicker from "@/components/timePicker";

export default {
    components: {
        TimePicker,
    },
    data() {
        return {
            times: [],
            pickerOptions: {
                disabledDate: time => {
                    return time.getTime() > Date.now();
                },
            }
        }
    },
    computed: {
        overviewList() {
            return this.getStorePorp("likeStatistic");
        },
        dataOverview() {
            return this.$t("zhiji.overview.dataOverview");
        },
        overviewItemLabel() {
            return function(type) {
                switch (type) {
                    case "feedback":
                        return this.$t("zhiji.likedisplay.feedbackRatePrint");
                    case "like":
                        return this.$t("zhiji.likedisplay.likeRatePrint");
                    case "question":
                        return this.$t("zhiji.likedisplay.quesTotal");
                }
            }
        },
        overviewItemIcon() {
            return function(type) {
                switch (type) {
                    case "feedback":
                        return "el-icon-chat-line-square";
                    case "like":
                        return "el-icon-star-off";
                    case "question":
                        return "el-icon-thumb";
                }
            }
        },
        overviewData() {
            return Object.keys(this.overviewList);
        },
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.likeDisplaySatis[propName];
        },
        dateChange(data) {
            const dates = {
                startTime: this.zhiji.dateFormat(data[0], "YYYY-MM-DD"),
                endTime: this.zhiji.dateFormat(data[1], "YYYY-MM-DD"),
            }
            this.$store.commit("zhiji/updateLikeDates", dates);
            this.$emit("dateChange", dates);
        },
    },
}
</script>

<style lang="less" scoped>
.data-overview {
    border-radius: 6px;
    padding: 10px;
    background-color: #fff;
    border: 1px solid #d8e4f0;
    .overview-title {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding-bottom: 8px;
        border-bottom: 1px solid #d8e4f0;
        .overview-title-text {
            font-size: 14px;
            font-weight: bold;
            color: #41475e;
        }
    }
    .overview-panel {
        display: flex;
        padding: 15px 0 10px;
        .panel-item {
            display: flex;
            align-items: center;
            margin-right: 150px;
            .item-icon {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                border: 1px solid #ccc;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 10px;
                i {
                    font-size: 26px;
                    color: #41475e;
                }
                .el-icon-star-off:before, .el-icon-star-on:before {
                    font-size: 26px;
                    color: #41475e;
                }
            }
            .item-data {
                display: flex;
                flex-direction: column;
                span:first-child {
                    font-size: 18px;
                }
                span:last-child {
                    color: #888;
                }
            }
        }
    }
}
</style>